import { FC } from 'react';
import styled from 'styled-components';
import Avatar from '../Avatar';
import dateFormat, { masks } from 'dateformat';

const Container = styled.div`
  padding: 0 max(10%, 148px);
`;

const Player = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
`;

const PlayerName = styled.h2(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.larger};
    font-weight: ${type.weight.bold};
    color: ${color.grayscale[0]};
  `;
});

const StatList = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    gap: 2rem;
    font-size: ${type.size.regular};
    font-weight: ${type.weight.regular};
    color: ${color.grayscale[0]};
    padding: 1.5rem 0 2rem;
    border-bottom: 1px solid ${color.grayscale[800]};
  `;
});

const Description = styled.span(({ theme }) => {
  const { type } = theme;

  return `
    font-weight: ${type.weight.bold};
  `;
});

export interface IPlayerHeader {
  player: {
    name: string;
    createdBy: string;
    dateCreated: Date;
    dateLastActive: string;
    skills: string[];
  };
}

const PlayerHeader: FC<IPlayerHeader> = ({ player }) => {
  const { name, createdBy, dateCreated, dateLastActive, skills } = player;
  const skillList = skills.join(', ');
  return (
    <Container>
      <Player>
        <Avatar name={name} />
        <PlayerName>{name || ''}</PlayerName>
      </Player>

      <StatList>
        <div>
          <Description>Card opened:</Description> {dateFormat(dateCreated, masks.mediumDate)}
        </div>

        <div>
          <Description>Opened by:</Description> {createdBy}
        </div>

        <div>
          <Description>Last Active Date:</Description> {dateFormat(dateLastActive, masks.mediumDate)}
        </div>

        {skillList.length > 0 && (
          <div>
            <Description>Targeted skills:</Description> {skillList}
          </div>
        )}
      </StatList>
    </Container>
  );
};

export default PlayerHeader;
